import React from "react"
import { browserHistory } from "react-router"
import { TextField, RaisedButton } from "material-ui"
import strings from "../../localization/strings"
import * as utils from "../../helpers/utils"
import autobind from "class-autobind"
import * as appStateActions from "../../actions/AppStateActions"
import * as api from "../../api"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import HtmlLoader from "../../components/layout/HtmlLoader"
import { IAccountManagerFESettings } from "../../models/data/account_manager/AccountManagerFESettings"
import AppStateStore from "../../stores/AppStateStore"

interface IState {
    email: string
    emailErrorText: string
    requestAttempted: boolean
    frontEndSettings: IAccountManagerFESettings
}

export default class ForgotPassword extends React.Component<null, IState> {
    constructor(props, context) {
        super(props, context)
        this.state = {
            email: "",
            emailErrorText: "",
            requestAttempted: false,
            frontEndSettings: null,
        }
        autobind(this)
    }

    componentWillMount() {
        AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
        appStateActions.getFrontEndSettings()
    }

    componentDidMount(): void {
        document.title = `${strings.Forgot_password} | ${strings.Findd_Grandd_Central}`
    }

    frontEndSettingsChange() {
        this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
    }

    handleRequestResetLink() {
        this.setState({ requestAttempted: true })
        if (!this.checkValidate()) return
        api.requestForgotPassword(this.state.email.trim())
        appStateActions.sentRequestResetPassword()
        browserHistory.push("/login")
    }

    checkValidate() {
        let valid = true
        if (!utils.validateEmail(this.state.email.trim())) {
            this.setState({ emailErrorText: strings.Valid_email_required })
            valid = false
        }
        else {
            this.setState({ emailErrorText: "" })
        }
        return valid
    }

    render() {
        if (!this.state.frontEndSettings) {
            return (
                <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%" }}><div style={{ padding: 20 }}>{strings.loading}</div></div>
            )
        }

        const forgotPassword = (
            <div style={{ textAlign: "center" }}>
                <h2> {strings.Forgot_your_password}</h2>
                <div>
                    {strings.Enter_your_email_address}
                </div>
                <div>
                    <TextField
                        floatingLabelText={strings.user_email}
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value }, () => this.state.requestAttempted && this.checkValidate())}
                        onKeyUp={event => event.keyCode === 13 && this.handleRequestResetLink()}
                        errorText={this.state.emailErrorText}
                        style={{ marginRight: 20, width: "100%", position: "relative" }}
                        errorStyle={{ position: "absolute", left: 0, right: 0, bottom: -12 }}
                        autoFocus
                    />
                    <div
                        id="ForgotPassword"
                        style={{ marginTop: 10, textAlign: "right", color: "rgba(0,0,0,0.4)", cursor: "pointer" }}
                        onClick={() => browserHistory.push("/login")}
                    >
                        {strings.Back_to_sign_in}
                    </div>
                    <RaisedButton
                        secondary
                        label={strings.Request_Reset_Link}
                        onClick={this.handleRequestResetLink}
                        style={{ marginTop: 20 }}
                    />
                </div>
            </div>
        )

        return (
            <RegistrationLayout
                leftContainer={forgotPassword}
                rightContainer={
                    <span style={{ padding: 30, color: "white" }}>
                        <HtmlLoader htmlUrl={this.state.frontEndSettings ? this.state.frontEndSettings.UISettings.LoginHTMLURL : null} />
                    </span>
                }
                loading={null}
                frontEndSettings={this.state.frontEndSettings}
            />
        )
    }
}